import { createSlice } from '@reduxjs/toolkit';

const LOCAL_KEY = 'products_json';

const mockProducts = [
  { id: 'prod1', name: 'Water Bottle', description: '500ml bottled water', price: 2, mainStock: 100, lowStockThreshold: 10, image: '', category: 'Drinks' },
  { id: 'prod2', name: 'Ice Cream Box', description: 'Box of 12 ice creams', price: 20, mainStock: 50, lowStockThreshold: 10, image: '', category: 'Snacks' },
  { id: 'prod3', name: 'Juice Pack', description: 'Pack of 6 juices', price: 10, mainStock: 80, lowStockThreshold: 10, image: '', category: 'Drinks' },
  { id: 'prod4', name: 'Snack Bar', description: 'Healthy snack bar', price: 5, mainStock: 200, lowStockThreshold: 10, image: '', category: 'Snacks' },
];

function loadProducts() {
  const json = localStorage.getItem(LOCAL_KEY);
  if (json) {
    try {
      return JSON.parse(json);
    } catch {
      return mockProducts;
    }
  }
  return mockProducts;
}
function saveProducts(products) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(products));
}

const initialState = {
  products: loadProducts(),
  filtered: loadProducts(),
  filters: {
    search: '',
  },
};

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filters = { ...state.filters, ...action.payload };
      let filtered = state.products;
      const { search, category } = state.filters;
      if (search) {
        const s = search.toLowerCase();
        filtered = filtered.filter(p => p.name.toLowerCase().includes(s) || p.description.toLowerCase().includes(s));
      }
      if (category && category !== 'All') {
        filtered = filtered.filter(p => p.category === category);
      }
      state.filtered = filtered;
    },
    resetFilters(state) {
      state.filters = { search: '' };
      state.filtered = state.products;
    },
    addProduct(state, action) {
      state.products.push({ ...action.payload, lowStockThreshold: action.payload.lowStockThreshold ?? 10, image: action.payload.image || '', category: action.payload.category || '' });
      state.filtered = state.products;
      saveProducts(state.products);
    },
    editProduct(state, action) {
      const idx = state.products.findIndex(p => p.id === action.payload.id);
      if (idx !== -1) {
        state.products[idx] = { ...action.payload, lowStockThreshold: action.payload.lowStockThreshold ?? 10, image: action.payload.image || '', category: action.payload.category || '' };
        state.filtered = state.products;
        saveProducts(state.products);
      }
    },
    removeProduct(state, action) {
      state.products = state.products.filter(p => p.id !== action.payload);
      state.filtered = state.products;
      saveProducts(state.products);
    },
    adjustStock(state, action) {
      // { id, amount } (amount can be positive or negative)
      const { id, amount } = action.payload;
      const idx = state.products.findIndex(p => p.id === id);
      if (idx !== -1) {
        state.products[idx].mainStock = Math.max(0, (state.products[idx].mainStock || 0) + amount);
        state.filtered = state.products;
        saveProducts(state.products);
      }
    },
    assignStockToRep(state, action) {
      // { productId, repId, quantity } - handled in UI, not stored here
      // This is a placeholder for future backend sync
    },
  },
});

export const { setFilter, resetFilters, addProduct, editProduct, removeProduct, adjustStock, assignStockToRep } = productSlice.actions;
export default productSlice.reducer; 